import React, { Component, Fragment } from 'react';
import { withTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import {
  ButtonSecondary,
  GelContentContainer,
  HeroBlock,
  Controls,
  FormErrorSummary,
  Notices,
  Loading,
  FormWrap,
  Role, InputLanguageSwitcher
} from "cw-styleguide-react";
import { BreadcrumbsItem } from "react-breadcrumbs-dynamic";
import { route } from "../../../routes";
import CoursesCreateEditForm from "../components/CoursesCreateEditForm";
import {
  ACTION_PUBLISH,
  ACTION_SAVE,
  ACTION_TRANSLATE,
  ACTION_QA,
  OPERATION_DUPLICATE,
  STATUS_DRAFT,
  ROLE_STAFF,
  ROLE_PROVIDER,
  OPERATION_CREATE,
  COURSE_TITLE_FIELD_COURSE
} from "../../../constants";
import withAssets from "../../../components/hoc/withAssets";

class CoursesCreateView extends Component {
  render() {
    if (!this.props.loaded && this.props.operation === OPERATION_DUPLICATE) {
      return (
        <GelContentContainer>
          <FormErrorSummary errors={this.props.formErrors} />
          <Loading text={this.props.t('local:view.courses.edit.messages.loading')} />
        </GelContentContainer>
      );
    }

    return (
      <Fragment>
        <Helmet>
          <title>{this.props.t('view.courses.create.title')}</title>
        </Helmet>
        <BreadcrumbsItem to={route('coursesManage') + '/' + route('coursesCreate')}>
          {this.props.t('view.courses.create.breadcrumb')}
        </BreadcrumbsItem>
        <GelContentContainer>
          <h1>{this.props.t('view.courses.create.title')}</h1>
        </GelContentContainer>
        <HeroBlock>
          <Role roles={[ROLE_STAFF]}>
            {this.props.t('view.courses.create.introductionStaff')}
          </Role>
          <Role roles={[ROLE_PROVIDER]}>
            {this.props.t('view.courses.create.introductionProvider')}
          </Role>
        </HeroBlock>
        <GelContentContainer>
          <Notices messages={this.props.messages} />
          <FormErrorSummary errors={this.props.formErrors} handleErrorClick={(e, field) => {
            // Set course title field if there is a course title error.
            if (this.props.formErrors['title_' + this.props.inputLanguage]) {
              this.props.handleSetTitleField(e, COURSE_TITLE_FIELD_COURSE);
            }

            this.props.handleErrorClick(e, field);
          }} />
          <FormWrap noPadding={true} noBackground={true}>
            <Controls>
              <ButtonSecondary
                url={route('coursesManage') + this.props.query}
                title={this.props.t('local:view.courses.create.controls.cancel')}
              >
                {this.props.t('local:view.courses.create.controls.cancel')}
              </ButtonSecondary>
              <Role roles={[ROLE_PROVIDER]}>
                <ButtonSecondary
                  disabled={this.props.isProcessing}
                  onClick={() => { this.props.saveCourse(this.props.getSaveState(STATUS_DRAFT, ACTION_QA)) }}
                  title={this.props.t('local:view.courses.create.controls.sendToQa')}
                >
                  {this.props.t('local:view.courses.create.controls.sendToQa')}
                </ButtonSecondary>
              </Role>
              <ButtonSecondary
                disabled={this.props.isProcessing}
                onClick={() => { this.props.saveCourse(this.props.getSaveState(STATUS_DRAFT, ACTION_SAVE)) }}
                title={this.props.t('view.courses.create.controls.save')}
              >
                {this.props.t('view.courses.create.controls.save')}
              </ButtonSecondary>
              <Role roles={[ROLE_STAFF]}>
                <ButtonSecondary
                  disabled={this.props.isProcessing}
                  onClick={() => { this.props.saveCourse(this.props.getSaveState(STATUS_DRAFT, ACTION_PUBLISH)) }}
                  title={this.props.t('view.courses.create.controls.publish')}
                >
                  {this.props.t('view.courses.create.controls.publish')}
                </ButtonSecondary>
                <ButtonSecondary
                  disabled={this.props.isProcessing}
                  onClick={() => { this.props.saveCourse(this.props.getSaveState(STATUS_DRAFT, ACTION_TRANSLATE)) }}
                  title={this.props.t('view.courses.create.controls.sendForTranslation')}
                >
                  {this.props.t('view.courses.create.controls.sendForTranslation')}
                </ButtonSecondary>
              </Role>
            </Controls>
            <Controls>
              <InputLanguageSwitcher language={this.props.inputLanguage} onChange={this.props.handleSetInputLanguage} />
            </Controls>
          </FormWrap>

          <CoursesCreateEditForm {...this.props} mode={OPERATION_CREATE} />
        </GelContentContainer>
      </Fragment>
    );
  }
}

export default withAssets(withTranslation('local')(CoursesCreateView));
